import { Navigate, type RouteObject } from "react-router";

/** Pantallas aprobadas con datos del servidor. Bodega y las líneas (Baldosa incluida) conservan sus rutas. */
export function withFlowRoutes(routes: RouteObject[]): RouteObject[] {
  return routes.map((route): RouteObject => {
    if (route.index) return route;
    return { ...route, children: route.children?.map((child): RouteObject => {
    if (child.index) return { index: true, lazy: async () => ({ Component: (await import("./pages")).FlowHome }) };
    if (child.path === "comercial") return { ...child, children: [
      // `/comercial` abre Pedidos; `/comercial/resumen` conserva su redirección a `flujo` con `?pedido=` (router).
      ...(child.children ?? []).map((entry): RouteObject => entry.index ? { index: true, element: <Navigate to="flujo" replace /> } : entry),
      { path: "flujo", lazy: async () => ({ Component: (await import("./pages")).FlowTrace }) },
      { path: "flujo/:orderId", lazy: async () => ({ Component: (await import("./pages")).FlowTrace }) },
    ] };
    return child;
  }).concat([
    { path: "inicio/resumen", lazy: async () => ({ Component: (await import("./pages")).FlowOverview }) },
    { path: "formulacion", lazy: async () => ({ Component: (await import("./FormulationAreas")).FormulationAreas }) },
    { path: "formulacion/tanques/planilla", lazy: async () => ({ Component: (await import("./planilla-tanques/PlanillaTanques")).PlanillaTanques }) },
    { path: "formulacion/labs", lazy: async () => ({ Component: (await import("@/features/labs/LabsPage")).LabsPage }) },
    { path: "diseno", lazy: async () => ({ Component: (await import("./pages")).FlowDesign }) },
  ]) };
  });
}
